import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RecaptchaModule } from 'ng-recaptcha';

import { LoginComponent } from './Login.component';
import { sesionesComponent } from './sesiones.component';
import { FuseForgotPassword2Component } from '../forgot-password-2/forgot-password-2.component';


const routes = [
    {
        path     : 'login',
        component: LoginComponent
    },
    {
        path     : 'victimas',
        component: LoginComponent
    },
    {
        path     : 'sesion/:usuario/:empresa/:idsesion',
        component: sesionesComponent
    },
    {
        path     : 'cambiar/:usuario/:empresa',
        component: FuseForgotPassword2Component
    }
];

@NgModule({
    declarations: [
        LoginComponent,
        sesionesComponent
    ],
    imports     : [
        SharedModule,
        RecaptchaModule.forRoot(),
        RecaptchaFormsModule,
        RouterModule.forChild(routes)
    ]
})

export class LoginModule
{

}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Login/Login.module.ts